


import React, { useState, useEffect } from 'react'
import { InputModel } from '../../../../../../../utils/types'
import { Item } from '../../../../../../../utils/types/generals'
import { icons } from '../../../../../../../utils/icons'
import { Box, InputAdornment } from '@mui/material'

const useInputList = ({ items }: { items?: { [x: string]: Item[] } }) => {
  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'filesManager.tags.search',
      translate: true,
      name: 'search',
      rest: {
        type: 'alphaNumeric',
      },
      value: null,
      wrapChildren: ({ children, id }) => {
        return React.cloneElement(children, {
          id,
          InputProps: {
            ...(children.props.InputProps ?? {}),
            endAdornment: (
              <InputAdornment position="end">
                {icons('search')}
              </InputAdornment>
            ),
          },
        });
      }
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
      },
    },
    userTypeId: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userTypeId',
      type: 'filter-select',
      items: items?.userTypeId ?? [],
      value: [],
      //notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
    roles: {
      label: 'general.tags.role',
      translate: true,
      name: 'roles',
      type: 'filter-select',
      items: items?.roles ?? [],
      value: null,
      //notAllowedRoles: [Roles.AGENT, Roles.AUDIT],
    },
  })

  useEffect(() => {
    let body = {}
    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInput(body)

  }, [items])

  return { input }
}

export { useInputList }
